// extracted by mini-css-extract-plugin
export var background = "_4k-0";
export var container = "_4k-1";
export var contentItem = "_4k-7";
export var extendedWarranty = "_4k-5";
export var link = "_4k-d";
export var modal = "_4k-b";
export var modalCloseButton = "_4k-9";
export var modalContent = "_4k-3";
export var modalContentMain = "_4k-6";
export var modalImageLogo = "_4k-8";
export var modalLogo = "_4k-a";
export var modalSideImage = "_4k-4";
export var preview = "_4k-c";
export var redoModal = "_4k-2";